import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { IConfigurationField } from '@/models/configuration/Field';
import { TableMenuActionColorEnums } from '@/enums/TableMenuActionEnums';

export interface IDataSetField {
    position: number;
    identifier: string;

    fields?: IDataSetField[];

    valueString?: string;
    valueNumber?: number | null;
    valueBool?: boolean;

    changed: boolean;
    color?: TableMenuActionColorEnums;
}

export class DataSetField implements IDataSetField {
    public position: number;
    public identifier: string;

    public fields?: DataSetField[];

    public valueString?: string;
    public valueNumber?: number | null;
    public valueBool?: boolean;

    public changed: boolean;
    public color: TableMenuActionColorEnums;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSetField);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationField);
    constructor(obj?: any) {
        this.position = (obj && obj.position) || 0;
        this.identifier = (obj && obj.identifier) || '';

        if (obj && obj.valueString != null) {
            this.valueString = obj.valueString;
        }
        if (obj && obj.valueNumber != null) {
            this.valueNumber = obj.valueNumber;
        }
        if (obj && obj.valueBool != null) {
            this.valueBool = obj.valueBool;
        }

        this.changed = obj && obj.changed != null ? obj.changed : false;
        this.color = obj && obj.color != null ? obj.color : TableMenuActionColorEnums.UNMARK;

        if (obj && obj.fields) {
            this.fields = [];
            for (const field of obj.fields) {
                this.fields.push(new DataSetField(field));
            }
        }
    }
}
